import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { DeletePersonStatus, MutationDeleteApteanAdminArgs } from '../gql-types.generated';
import { getStandardHeaders } from '../util/StandardRequestHeaders';

// eslint-disable-next-line @typescript-eslint/naming-convention
const MUTATION_DELETE_APTEAN_ADMIN = gql`
  mutation deleteApteanAdmin($input: DeletePersonInput!) {
    deleteApteanAdmin(input: $input) {
      code
      message
      error
    }
  }
`;

export const mutationDeleteApteanAdmin = async (
  client: ApolloClient<NormalizedCacheObject>,
  id: string,
): Promise<DeletePersonStatus | undefined> => {
  const headers = await getStandardHeaders(true);
  const { data, errors } = await client.mutate<{ deleteApteanAdmin: DeletePersonStatus }, MutationDeleteApteanAdminArgs>({
    variables: { input: { id } },
    mutation: MUTATION_DELETE_APTEAN_ADMIN,
    context: { headers },
  });
  if (errors && errors.length > 0) {
    errors.forEach(error => console.error(error));
    throw new Error('An error has occurred during the aptean admin delete.');
  }
  if (data && data.deleteApteanAdmin) {
    return data.deleteApteanAdmin;
  }
  return undefined;
};
